import { render, staticRenderFns } from "./default.vue?vue&type=template&id=45876dac"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderDefault: require('C:/cata1og/cata1og-store/components/header/header-default.vue').default,FooterDefault: require('C:/cata1og/cata1og-store/components/footer/footer-default.vue').default,SidebarCart: require('C:/cata1og/cata1og-store/components/sidebar/cart.vue').default,SidebarAccount: require('C:/cata1og/cata1og-store/components/sidebar/account.vue').default,SidebarMenu: require('C:/cata1og/cata1og-store/components/sidebar/menu.vue').default,SidebarSearch: require('C:/cata1og/cata1og-store/components/sidebar/search.vue').default})
